import { STATUS_OPTIONS } from './eventTypes';

  // ── Helpers ────────────────────────────────────────────────

export const getStatusBadge = (status: string) => {
    const s = STATUS_OPTIONS.find(o => o.value === status);
    return s ? s.color : 'bg-gray-500/20 text-gray-400 border-gray-400/30';
  };

export const getStatusLabel = (status: string) => {
    const s = STATUS_OPTIONS.find(o => o.value === status);
    return s ? s.label : status;
  };

export const formatDate = (d: string) => d ? new Date(d).toLocaleString() : '—';
export const formatShortDate = (d: string) => d ? new Date(d).toLocaleDateString() : '—';

